import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Employee } from '../data/employee';
import { Observable } from 'rxjs';
import { ValidEmployeeOrgUnit } from '../data/valid-employee-org-unit';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  private http = inject(HttpClient);

  controllerURL = '/api/employees';

  getMyApprovers(): Observable<Employee> {
    return this.http.get<Employee>(environment.apiUrl + this.controllerURL + '/check-data');
  }

  getValidOrgUnits(): Observable<ValidEmployeeOrgUnit[]> {
    return this.http.get<ValidEmployeeOrgUnit[]>(environment.apiUrl + this.controllerURL + '/org-units/valid');
  }

  setOrgUnitAsActive(id: string | undefined): Observable<void> {
    if (id) {
      return this.http.patch<void>(environment.apiUrl + this.controllerURL + '/org-units/' + id + '/active', null);
    } else {
      return this.http.delete<void>(environment.apiUrl + this.controllerURL + '/org-units/active');
    }
  }
}
